import {
	appealNoticeConstants
}from './constants'
import {
	defAction
}from '../../../../../helpers/defaultAction'
import api from './api'
import downloadFile from '../../../../../helpers/downloadFile'

export const appealNoticeActions = {
	EditOrgAppealNotice,
	ClearOrgAppealNotice,
	DownloadAppealNoticeFile,
	GetAppealNotice
}

function EditOrgAppealNotice(params){
	const dispatchObj = {
		constants : appealNoticeConstants.EditOrgAppealNotice,
		service   : {
			func   : api.EditOrgAppealNotice,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function GetAppealNotice(params){
	const dispatchObj = {
		constants : appealNoticeConstants.GetAppealNotice,
		service   : {
			func   : api.GetAppealNotice,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function ClearOrgAppealNotice(){
	return dispatch => dispatch({ type: appealNoticeConstants.ClearOrgAppealNotice })
}

function DownloadAppealNoticeFile(params, fileName, fileExtension){
	const dispatchObj = {
		constants : appealNoticeConstants.DownloadAppealNoticeFile,
		service   : {
			func   : api.DownloadAppealNoticeFile,
			params : params
		},
		sucFunction: (res) => {
			downloadFile(res, {fileName, fileExtension})
		}
	}
	return defAction(dispatchObj)
}
